<script>
export default {
  name: 'DefaultLayout',
  data() {
    return {

    };
  },
};
</script>

<template lang="pug">
.default-layout
  slot
</template>

<style lang="stylus" scoped></style>



// WEBPACK FOOTER //
// DefaultLayout.vue?760e7000